/*
 * 需要在主js里导入,以获得 landingPageUrl
 * */

import wx from "weixin-js-sdk";
import debounce from "lodash/debounce";
import api from "../api/api";
import storeDebugSettings from "../store/storeDebugSettings";

const Jwx = {};

// 需要检测的JS接口列表
const jsApiList = [
  "checkJsApi",
  "openEnterpriseChat",
  "openEnterpriseContact",
  "onMenuShareTimeline",
  "onMenuShareAppMessage",
  "onMenuShareQQ",
  "onMenuShareWeibo",
  "onMenuShareQZone",
  "startRecord",
  "stopRecord",
  "onVoiceRecordEnd",
  "playVoice",
  "pauseVoice",
  "stopVoice",
  "onVoicePlayEnd",
  "uploadVoice",
  "downloadVoice",
  "chooseImage",
  "previewImage",
  "uploadImage",
  "downloadImage",
  "translateVoice",
  "getNetworkType",
  "openLocation",
  "getLocation",
  "hideOptionMenu",
  "showOptionMenu",
  "hideMenuItems",
  "showMenuItems",
  "hideAllNonBaseMenuItem",
  "showAllNonBaseMenuItem",
  "closeWindow",
  "scanQRCode",
  "getLocalImgData"
];

// wx接口默认参数
const methodDefaultOpt = {
  chooseImage: {
    count: 9,
    sizeType: ["original", "compressed"], // 可以指定是原图还是压缩图，默认二者都有
    sourceType: ["album", "camera"] // 可以指定来源是相册还是相机，默认二者都有
  }
};

// 记录已经授权签名的url
let wxConfigReadyUrl = "";
const landingPageUrlPromise = getLandingPageUrl();
const miniProgramLandingPageUrl = getLocationHref(); // getUrl();

function isWeiXin() {
  const ua = window.navigator.userAgent.toLowerCase();
  return /MicroMessenger/i.test(ua);
}

function isIOS(userAgent = navigator.userAgent) {
  return userAgent.match(/ipad|iphone|ipod/i);
}

function isAndroid(userAgent = navigator.userAgent) {
  return userAgent.match(/android/i);
}

function wxJSBridgeReady(cb) {
  if (-1 !== navigator.userAgent.toLowerCase().indexOf("micromessenger")) {
    if (!window.WeixinJSBridge || !window.WeixinJSBridge.invoke) {
      document.addEventListener("WeixinJSBridgeReady", cb, false);
    } else {
      cb();
    }
  } else {
    cb();
  }
}

const _isMini = new Promise((resolve, reject) => {
  wxJSBridgeReady(resolve);
}).then(() => {
  return window.__wxjs_environment === "miniprogram";
});

function isMiniProgram() {
  return _isMini;
}

function getUrl() {
  return window.location.href.split("#")[0];
}

// 获取最初的location.href
function getLocationHref() {
  // 这个变量需要在index.html页面设置
  return window.__locationHref && window.__locationHref.split("#")[0];
}

function wxVersionLargerThan633() {
  const str = window.navigator.userAgent;
  const v0 = [6, 3, 31];
  const regExp = /MicroMessenger\/([\d|\.]+)/;
  if (regExp.exec(str) === null) {
    return;
  }
  let v1 = regExp.exec(str)[1].split(".");
  if (v1.length >= 4) {
    v1 = v1.slice(0, 3);
  }
  v1 = v1.map(function(v) {
    return parseInt(v, 10);
  });
  if (v1[0] > v0[0]) {
    return true;
  } else if (v1[0] === v0[0] && v1[1] > v0[1]) {
    return true;
  } else if (v1[0] === v0[0] && v1[1] === v0[1] && v1[2] >= v0[2]) {
    return true;
  }
  return false;
}

// 获取首次加载的url
async function getLandingPageUrl() {
  // 这里进行延迟是为了解决landingPage被redirect的情况, 例如 /front/ 跳转到 /front/home/
  // 还有redirect到login的情况
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(getUrl());
    }, 300);
  });
}

// 获取要签名的url
async function getSignUrl() {
  /*
  把第一次打开的页面叫做进入页；把前端路由若干次跳转（通过pushState/replaceState改变url）之后，当前打开的页面叫做当前页。
  微信验签使用的url（当前网页的URL，不包含#及其后面部分），在Android下取的是当前页url，在IOS下取的是进入页的url（支付目录也是一样）
   */
  /*
  1：安卓微信6.2.7版
  将第一次进入页面的地址保存，之后每次页面改变（即URL变化），就调用一次config。url使用第一次进入页面的URL

  2：安卓微信6.5.7版
  每次URL变化都调用config，但是URL使用当前url

  3：iOS版微信
  只需要进入第一个页面之后调用一次
   */
  // https://blog.csdn.net/github_37519401/article/details/78406159

  let signUrl = getUrl();
  const isMini = await isMiniProgram();
  if (isAndroid()) {
    if (isMini) {
      signUrl = miniProgramLandingPageUrl;
      console.log(`isMiniProgram--signUrl:${signUrl}`);
    } else {
      if (wxVersionLargerThan633()) {
        signUrl = getUrl();
      } else {
        signUrl = await landingPageUrlPromise;
      }
    }
  }
  if (isIOS()) {
    signUrl = await landingPageUrlPromise;
  }
  return signUrl;
}

async function getSignData() {
  const signUrl = await getSignUrl();
  return new Promise((resolve, reject) => {
    api.weixinJsSdkSignDebounce(signUrl, ({ data, _data }) => {
      if (data && _data && data.code === 1000) {
        resolve(_data);
      } else {
        reject({
          type: "service",
          msg: "/wechat/weixin/signature: 后台签名接口返回数据格式错误",
          signUrl,
          data
        });
      }
    });
  });
}

async function getConfigData() {
  const data = await getSignData();
  return {
    debug: storeDebugSettings.jssdkDebug,
    appId: data.app_id,
    timestamp: data.timestamp,
    nonceStr: data.nonce_str,
    signature: data.signature,
    jsApiList: jsApiList
  };
}

async function setSign(signUrl) {
  const configData = await getConfigData();
  return new Promise((resolve, reject) => {
    let configFailed = false;
    console.log("开始执行wx.config", configData);
    wx.config(configData);
    wx.error(res => {
      configFailed = true;
      wxConfigReadyUrl = "";
      console.error("wx.error", res);
    });
    // 失败和成功都会执行的回调
    // 不管成功还是失败我们都认为签名准备好了
    // 如果出错可能是后台验签或微信本身验签问题
    wx.ready(() => {
      if (!configFailed) {
        wxConfigReadyUrl = signUrl;
      }
      resolve();
    });
  });
}

export async function signReady() {
  return new Promise(async (resolve, reject) => {
    if (isWeiXin()) {
      // 这里要判断一下, 安卓始终要config, 苹果只需要config一次
      if (wxConfigReadyUrl && isIOS()) {
        console.log(`已经ready:${wxConfigReadyUrl}`);
        wx.ready(() => {
          resolve();
        });
      } else {
        const signUrl = await getSignUrl();
        // 如果当前url已经经过签名了, 那么就不用重复签名
        if (wxConfigReadyUrl === signUrl) {
          console.log(`已经ready:${signUrl}`);
          wx.ready(() => {
            resolve();
          });
        } else {
          console.log("重新拉取jssdk sign执行wx.config", signUrl);
          resolve(setSign(signUrl));
        }
      }
    } else {
      resolve();
    }
  });
}

function checkSingError(str) {
  str = str || "";
  return (
    str.indexOf("permission denied") !== -1 ||
    str.indexOf("invalid signature") !== -1
  );
}

/**
 * 调用微信方法
 * @param method
 * @param retry 因签名失败想重复调用的次数
 * @param options
 * @returns {Promise}
 */
async function _addRawCallWxMethod({ method, retry = 1 }, options) {
  return new Promise((resolve, reject) => {
    const { _rawSuccess, _rawFail } = options;

    options.success = res => {
      typeof _rawSuccess === "function" && _rawSuccess(res);
      resolve(res);
    };
    options.fail = async res => {
      console.error(`retry`, retry > 0 && checkSingError(res.errMsg));
      if (retry > 0 && checkSingError(res.errMsg)) {
        // 重新签名
        wxConfigReadyUrl = "";
        await signReady();
        resolve(_addRawCallWxMethod({ method, retry: retry - 1 }, options));
      } else {
        typeof _rawFail === "function" && _rawFail(res);
        console.error(res);
        reject(res);
      }
    };
    wx[method](
      methodDefaultOpt[method]
        ? { ...methodDefaultOpt[method], ...options }
        : options
    );
  });
}

/**
 * 调用微信方法
 * @param method
 * @param retry 因签名失败想重复调用的次数
 * @param options
 * @returns {Promise}
 */
function callWxMethod({ method, retry = 1 }, options = {}) {
  return _addRawCallWxMethod(
    { method, retry },
    {
      _rawSuccess: options.success,
      _rawFail: options.fail,
      ...options
    }
  );
}

jsApiList.forEach(method => {
  const func = (Jwx[method] = async function(options) {
    await signReady();
    return callWxMethod({ method }, options);
  });
  Jwx[`${method}Debounce`] = debounce(func, 500);
});

export default Jwx;



// WEBPACK FOOTER //
// ./src/utils/jweixin.js